import React from "react";
import Lottie from "lottie-web";
import Animation from "../../../../../static/animations/benefit-with-zmts.json";

export default function BenefitWithZMTs() {
  React.useEffect(() => {
    Lottie.loadAnimation({
      container: document.querySelector("#benefit-with-zmts"),
      animationData: Animation,
      renderer: "svg", // "canvas", "html"
      loop: true, // boolean
      autoplay: true, // boolean
    });
  }, []);

  return (
    <>
      <div id="benefit-with-zmts" />
    </>
  );
}
